import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { UserAccountService } from '../user-account.service';
import { DateUtils } from '../util/date-utils';

@Component({
  selector: 'app-remote-auth-modal',
  templateUrl: './remote-auth-modal.component.html',
  styleUrls: ['./remote-auth-modal.component.scss'],
  standalone: false
})
export class RemoteAuthModalComponent implements OnInit, OnDestroy {
  visible = false;
  agentName = '';
  agentId = '';
  requestId = '';
  expiresAt = 0;
  responding = false;
  private subs: Subscription[] = [];

  constructor(
    public userAccountService: UserAccountService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.subs.push(
      this.userAccountService.pendingAuthRequest$.subscribe(req => {
        if (req && req.requestId) {
          this.requestId = req.requestId;
          this.agentName = req.agentName || 'Routespring Agent';
          this.agentId = req.agentId || '';
          this.expiresAt = req.expiresAt || 0;
          this.responding = false;
          this.visible = true;
        } else {
          this.visible = false;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  // BUG1033/13858: was displayed as raw total minutes (e.g. "1440 minutes"); the agreed
  // display format for this family of session-duration timers is HH:MM:SS (see date-utils.ts's
  // formatCountdown, already used the same way by help-popup.component.ts's session timer).
  get approvedSessionDurationFormatted(): string {
    return DateUtils.formatCountdown(this.userAccountService.approvedSessionDurationMinutes * 60);
  }

  authorize(): void {
    this.respond('APPROVE');
  }

  decline(): void {
    this.respond('DENY');
  }

  private respond(action: 'APPROVE' | 'DENY'): void {
    if (this.responding) return;
    this.responding = true;
    this.userAccountService.respondToAuthRequest(this.requestId, action).subscribe({
      next: (res: any) => {
        this.visible = false;
        this.userAccountService.pendingAuthRequest$.next(null);
        if (action === 'APPROVE') {
          const sessionExpiresAt = res?.data?.expiresAt || this.expiresAt;
          this.userAccountService.approvedSession$.next({
            requestId: this.requestId,
            agentName: this.agentName,
            agentId: this.agentId,
            expiresAt: sessionExpiresAt
          });
          this.toastr.success('Remote assistance session is now active.', 'Session Started');
        } else {
          this.toastr.info('You have declined the access request.', 'Request Declined');
        }
      },
      error: () => {
        this.responding = false;
        this.toastr.error('Failed to process your response. Please try again.', 'Error');
      }
    });
  }
}
